import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry } from '../../../lib/components';
import { dateFormat, ReactNodeGenerator } from '../../../lib/helpers';
import { routes } from '../../../pages/Routes';
import { TeacherLessonsSceneStore } from './TeacherLessonsSceneStore';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import $ from 'jquery';
import { Disposers } from 'lib/helpers';
import { action, observable, reaction } from 'mobx';
import Swal from 'sweetalert2';
import moment from 'moment';
import { routerStore } from "lib/components/router/routerStore";
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';


const defaultStartTime: string = "09:00";
const defaultEndTime: string = "18:00";

function* renderRows(store: TeacherLessonsSceneStore): ReactNodeGenerator {
  if (store.LessonsState?.isResolved !== true)
    return;

  const lessons = store.LessonsState.value.Lessons;
  for (let lesson of lessons) {
    yield (
      <tr key={lesson.ClassRoomId} className={moment.utc(lesson.Start).toDate()>=moment.utc().toDate()? 'in-future': ''}>
        <td>
          {lesson.Title}
        </td>
        <td>
          {lesson.Start}-{lesson.End}
        </td>
        <td>
          {lesson.StudentName}
        </td>
        <td>
          {lesson.Status}
        </td>
        <td>
          <button className="btn btn-primary btn-action-marker" onClick={() => { btnActionPreviewLesson(lesson.ClassRoomId) }}>Preview</button>
        </td>
      </tr>
    );
  }
}

function* renderer(store: TeacherLessonsSceneStore): ReactNodeGenerator {
  if (store.LessonsState === null) {
    return;
  }
  const state = store.LessonsState;
  yield (<PromiseMessage key="loader-state"
    label="Loading lessons" state={state} align="right" />);

  if (!state.isResolved)
    return;

  yield (
    <div key="working-days">
      <div className="row">
        <h1>My Lessons</h1>
      </div>
      <div className="row" key="schedule">
        <div className="col">
          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th>Lesson</th>
                <th>Date</th>
                <th>Student</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Array.from(renderRows(store))}
            </tbody>
          </table>
        </div>
      </div>
    </div>);
}

function btnActionPreviewLesson(classroomId: number){
  const url = routes.teacherClassroom(classroomId);
  routerStore.navigateTo(url + "?preview");
}

@observer
export class TeacherLessonsScene extends React.Component {
  store: TeacherLessonsSceneStore;

  constructor(props: any) {
    super(props);
    this.store = new TeacherLessonsSceneStore();
  }

  componentDidMount() {
    this.store.load();
  }

  

  render() {
    return Array.from(renderer(this.store));
  }
}